import { useMutation, useQuery } from '@tanstack/react-query';

import cycleQuestionnaireService from './cycleQuestionnaireService';

import type { UseGetCycleQuestionnaireParams } from './types';
import type { ImportTemplateParams } from '@/api/review-services/review-questionnaire/types';
import type { CycleQuestionnaire } from '@/types/cycle-evaluation/CycleQuestionnaire';

import { queryClient } from '@/AppWithProviders';
import { CycleEvaluationQueryKey, CycleQuestionnaireQueryKey } from '@/constants/QueryKeys';

const useGetCycleQuestionnaire = ({
    cycleQuestionnaireId,
    options,
}: UseGetCycleQuestionnaireParams) => {
    return useQuery<CycleQuestionnaire>({
        queryKey: [CycleQuestionnaireQueryKey.CYCLE_QUESTIONNAIRE, cycleQuestionnaireId],
        queryFn: () => cycleQuestionnaireService.getCycleQuestionnaire(cycleQuestionnaireId!),
        enabled: !!cycleQuestionnaireId,
        ...options,
    });
};

const useUpdateCycleQuestionnaire = () => {
    return useMutation({
        mutationFn: (questionnaire: CycleQuestionnaire) =>
            cycleQuestionnaireService.updateCycleQuestionnaire(questionnaire),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: [CycleEvaluationQueryKey.CYCLE_EVALUATION],
            });
        },
    });
};

const useImportTemplateInCycleQuestionnaire = () => {
    return useMutation({
        mutationFn: (payload: ImportTemplateParams) =>
            cycleQuestionnaireService.importTemplateInQuestionnaire(payload),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: [CycleEvaluationQueryKey.CYCLE_EVALUATION],
            });
        },
    });
};

export {
    useGetCycleQuestionnaire,
    useUpdateCycleQuestionnaire,
    useImportTemplateInCycleQuestionnaire,
};
